import { showNotification } from '@mantine/notifications';
import { FileRejection } from 'react-dropzone';
import { X } from 'tabler-icons-react';
import { CardType } from '../enums/retrieve-transaction.enums';

export function getCardTypeName(cardType?: CardType) {
  if (cardType === CardType.VISA) {
    return 'Visa';
  } else if (cardType === CardType.MASTERCARD) {
    return 'Mastercard';
  } else if (cardType === CardType.AMERICAN_EXPRESS) {
    return 'American Express';
  } else if (cardType === CardType.DINERS) {
    return 'Diners';
  } else if (cardType === CardType.DISCOVER) {
    return 'Discover';
  } else if (cardType === CardType.JCB) {
    return 'JCB';
  } else if (cardType === CardType.CHINABANK) {
    return 'ChinaBank';
  } else if (cardType === CardType.CITIBANK) {
    return 'Citibank';
  } else if (cardType === CardType.BARCLAY_CARD) {
    return 'Barclay Card';
  } else if (cardType === CardType.DEBIT) {
    return 'Debit';
  } else if (cardType === CardType.CHEQUE) {
    return 'Cheque';
  } else if (cardType === CardType.CASH) {
    return 'Cash';
  } else if (cardType === CardType.EBT) {
    return 'EBT';
  } else if (cardType === CardType.OFFLINE) {
    return 'Offline';
  } else if (cardType === CardType.PAYMAYA_QR) {
    return 'PayMaya QR';
  } else if (cardType === CardType.GCASH_QR) {
    return 'GCash QR';
  } else if (cardType === CardType.PAYMAYA_QR_PH) {
    return 'PayMaya QR PH';
  } else if (cardType === CardType.PAYMAYA_WALLET_LINK) {
    return 'PayMaya Wallet Link';
  } else if (cardType === CardType.AUB) {
    return 'AUB';
  } else {
    return undefined;
  }
}

export const truncateString = (str: string, num: number): string => {
  if (str.length > num) {
    return str.slice(0, num) + '...';
  } else {
    return str;
  }
};

export const formatNumberWithCommasAndDecimals = (number: number) => {
  return number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

function handleFileRejection(
  fileRejections: FileRejection[],
  maxFileSizeMB: number
) {
  const reject = fileRejections[0];
  const fileName = reject.file.name;
  const fileNameLength = fileName.length;
  let fileNameDisplay = fileName;

  if (fileNameLength > 25) {
    fileNameDisplay =
      fileName.substring(0, 14) +
      '...' +
      fileName.substring(fileNameLength - 8, fileNameLength);
  }

  const errorMessage =
    reject.errors[0].code === 'file-too-large'
      ? `File is larger than ${maxFileSizeMB} MB`
      : reject.errors[0].message;

  showNotification({
    id: 'update-file-upload-reject',
    message: `${fileNameDisplay} was not uploaded: ${errorMessage}`,
    icon: <X size={16} />,
    color: 'red',
  });
}

export default handleFileRejection;
